export const extraComponentStyles = (_theme) => {
  return `
    @keyframes shimmer {
        0% {
            background-position-x: 100%
        }
        5% {
          background-position-x: 0%
        }
        100% {
            background-position-x: 0%
        }
      }

    }
`;
};
